import axios from 'axios';
import { redirectToLogin } from '../utils/deferredNavigation';
import { captureAllowToken } from './allowToken';
import { unrestrictedRoutes } from '../permisiions';
const practiseid = 1111;
const dallasapi = axios.create({
  baseURL: process.env.REACT_APP_API_DALLAS_BASE || 'https://api.prd.brainymed.com/dallas',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});
// ?allowtoken=: never stores the public intake token (see ./allowToken).
captureAllowToken('dallasapi');

dallasapi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      localStorage.removeItem('auth');
    //  window.location.replace('/auth');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
let isRefreshing = false;

// True when no staff token is stored and the page is a sign-in-free route
// (permisiions.js unrestrictedRoutes).
const isAnonymousOnPublicPage = () => {
  try {
    if (window.localStorage.getItem('auth')) return false;
    const path = window.location.pathname || '';
    return unrestrictedRoutes.some((route) => path.startsWith(route));
  } catch (e) {
    return false;
  }
};

const refreshAuthToken = async () => {
  try {
    const accessToken = localStorage.getItem('auth');
    const response = await dallasapi.post(
      `/v1/${practiseid}/auth/refresh-token`,
      { "access_token": accessToken },
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (response && response.status === 200) {
      localStorage.setItem('auth', response.refresh_token);
      return response.refresh_token;
    } else {
     //localStorage.removeItem('auth');
      redirectToLogin(); // queued while a recording runs (utils/deferredNavigation)
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    //localStorage.removeItem('auth');
    redirectToLogin(); // queued while a recording runs (utils/deferredNavigation)
    console.error("Failed to refresh token:", error);
    throw error;
  }
};

dallasapi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry
        && isAnonymousOnPublicPage()) {
      // Nobody is signed in on a sign-in-free page (patient intake, the TV
      // board): there is no token to refresh, and a redirect to /login would
      // take the visitor off the page. The call just fails.
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const newToken = await refreshAuthToken();
          if (newToken) {
            
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            isRefreshing = false;

            return dallasapi(originalRequest);
          }
        } catch (refreshError) {
          isRefreshing = false;
          return Promise.reject(refreshError);
        }
      } else {
    
       // localStorage.removeItem('auth');
     
        return Promise.reject(error);
      }
    }

    if (!originalRequest._retry) {
      //localStorage.removeItem('auth');
    }

    return Promise.reject(error);
  }
);

export default dallasapi;
